import {
    NotificationTypes,
} from '../services/types/vessel-notifications-services.types'
import { UnifiedNotification } from './types/vessel-notifications.types'
export abstract class VesselNotificationsModelBase extends EventTarget {
    abstract updateSyncStatus(
        url: string,
        status: 'submitted' | 'complete' | 'failed',
    ): void

    // get all notifications (sync, alarms, etc.)
    abstract get notifications(): UnifiedNotification[]

    abstract getNotificationsByType(type: NotificationTypes): UnifiedNotification[]

    abstract loadSyncNotifications(): Promise<void>

    abstract checkBasicPlanAvailable(schdeules: []): Promise<void>

    abstract loadWeatherAlarms(): Promise<void>

    abstract getWeatherAlarm(type: NotificationTypes.HeavyWeather | NotificationTypes.ParametricRoll | NotificationTypes.HeavyRolling | NotificationTypes.HighAccelerationForce): UnifiedNotification | undefined
}

let VesselNotificationsModel: VesselNotificationsModelBase | null = null

function setVesselNotificationsModel(
    model: VesselNotificationsModelBase,
): void {
    VesselNotificationsModel = model
}

export { VesselNotificationsModel, setVesselNotificationsModel }
